<template>
    <div>
        <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{paddingTop: 0, paddingBottom: '20px' }">
            <a-form-model >

                <!-- Current Waiting time -->
                <a-row type="flex" :gutter="24">
                    <a-col :span="24" :lg="6" class="mb-24">
                        <a-form-model-item class="mb-10"
                                        label="Current waiting time"
                        >
                            <a-slider :min="5" :max="60" :step="1" 
                                        v-model="orderManager.currentWaitingTime"
                            />
                        </a-form-model-item>
                    </a-col>

                    <a-col :span="24" :lg="6" class="mb-24">
                        <a-form-model-item class="mb-10"
                                            label="Capacity"
                        >
                            <a-slider :min="1" :max="20" :step="1" 
                                                v-model="orderManager.capacity"
                            />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <!-- / Current Waiting time -->

                <!-- Min,Max Waiting time -->
                <a-row type="flex" :gutter="24">
                    
                    <a-col :span="24" :lg="6" class="mb-24">
                        <a-form-model-item class="mb-10"
                                        label="Min waiting time"
                        >
                            <a-slider :min="5" :max="60" :step="1" 
                                        v-model="orderManager.minWaitingTime"
                            />
                        </a-form-model-item>
                    </a-col>

                    <a-col :span="24" :lg="6" class="mb-24">
                        <a-form-model-item class="mb-10"
                                        label="Max waiting time"
                        >
                            <a-slider :min="10" :max="60" :step="1" 
                                        v-model="orderManager.maxWaitingTime"
                            />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <!-- / Min,Max Waiting time -->

                <!-- Increase Time Step -->
                <a-row type="flex" :gutter="24">
                    
                    <a-col :span="24" :lg="6" class="mb-24">
                        <a-form-model-item class="mb-10"
                                            label="Increase Time Step"
                        >
                            <a-slider :min="1" :max="20" :step="1" 
                                                v-model="orderManager.increaseTimeStep"
                            />
                        </a-form-model-item>
                    </a-col>

                    <a-col :span="24" :lg="6" class="mb-24">
                        <a-form-model-item class="mb-10"
                                            label="Pending Orders Increase Step"
                        >
                            <a-slider :min="1" :max="20" :step="1" 
                                                v-model="orderManager.pendingOrdersIncreaseStep"
                            />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <!-- / Increase Time Step -->

                 <!-- Init time of order -->
                <a-row type="flex" :gutter="24">
                    
                    <a-col :span="24" :lg="6" class="mb-24">
                        <a-form-model-item class="mb-10"
                                            label="Init Time of order"
                        >
                            <a-slider :min="1" :max="20" :step="1" 
                                                v-model="orderManager.initTimeOfOrder"
                            />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <!-- / Init time of order -->

                <!-- Can order from, cannot order from, off time -->
                <a-row type="flex" :gutter="24">
                    <a-col :span="24" :lg="6" class="mb-24">
                        <a-form-model-item class="mb-10"
                                            label="Off time"
                        >
                            <a-time-picker format="HH:mm" 
                                            v-model="orderManager.offTime" 
                            />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <!-- / Can order from, cannot order from, off time -->

                
            </a-form-model>
            <a-row>
            
			</a-row> 
        </a-card>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {

    computed : {
        ...mapState({
            orderManager : state => state.orderManager.orderManagerState
        })
    },
    data() {
        return {
            isEditable : false
        }
    },

    methods : {
        handleBtnUpdate() {

        },
        handleBtnEdit() {

        },
        handleBtnCancel() {

        }
    },
    async created () {
        await this.$store.dispatch('orderManager/getOrderManagerStateAction', {});
    }
}
</script>

<style>

</style>